import axios from "axios";
import { setupCache } from "axios-cache-interceptor";

export const cacheResponse = setupCache(axios, {
  maxAge: 86400000,
});
